import styled from 'styled-components';

export const BoxExpandContent = styled.div`
  display: flex;
  flex-direction: column;

  & > div:not(:last-child) {
    margin-bottom: 12px;
  }

  .ant-checkbox + span {
    word-break: break-word;
  }
`;
